import React from 'react';
import {
  LightBulbIcon,
  SparklesIcon,
  RocketLaunchIcon,
  EnvelopeIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';

const LeverageAIFinalThoughts = () => {
  return (
    <div className="space-y-8">
      <PlaybookSection
        title="Final Thoughts"
        icon={<LightBulbIcon className="h-7 w-7 text-primary-light" />}
        heading
      >
        <PlaybookCard>
          <div className="prose prose-invert max-w-none">
            <div className="p-4 border-l-4 border-primary-light bg-gray-900/30 rounded-r-lg mb-6">
              <p className="text-gray-300 mb-2">
                Here's the thing: you don't need a massive transformation strategy.
              </p>
              <p className="text-gray-300 mb-2">
                You just need to get people excited, show them what's working, and keep the momentum going.
              </p>
            </div>

            <div className="space-y-4 mb-6">
              <p className="text-gray-300 leading-relaxed">
                The best AI adoption happens when it doesn't feel like "AI adoption" at all. It feels like finding better ways to work.
              </p>

              <p className="text-gray-300 leading-relaxed">
                Start with the stuff that's genuinely annoying your team. Build something small that actually helps. Let people play around and see what happens. Share the wins (even the scrappy ones) so others get curious.
              </p>

              <p className="text-gray-300 leading-relaxed">
                And for the love of all that's good—don't turn this into a policy marathon. People need to experiment, not navigate a 47-page compliance document.
              </p>
            </div>

            <div className="bg-primary/10 border border-primary/30 rounded-lg p-6 mb-6">
              <h3 className="text-xl font-semibold text-white mb-4">What We've Learned</h3>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-start">
                  <span className="text-primary-light mr-3">—</span>
                  <span>The teams crushing it aren't the ones with the biggest budgets or fanciest tools</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-light mr-3">—</span>
                  <span>They're the ones that made trying new things feel safe and worthwhile</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-light mr-3">—</span>
                  <span>Success comes from solving real problems, not checking technology boxes</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-light mr-3">—</span>
                  <span>The magic happens when people stop asking "Should we use AI?" and start asking "How can this help?"</span>
                </li>
              </ul>
            </div>

            <div className="space-y-4">
              <p className="text-gray-300 leading-relaxed">
                Your role isn't to become the AI expert or build everything yourself. It's to create the conditions where smart people can figure things out and share what works.
              </p>

              <p className="text-gray-300 leading-relaxed">
                So go plant some seeds. Set up the garden walls. And cheer really loudly when someone ships something weird but genuinely useful. 
              </p>

              <p className="text-gray-300 font-medium">
                That's how culture shifts happen—one small, helpful thing at a time.
              </p>
            </div>
          </div>
        </PlaybookCard>
      </PlaybookSection>
    </div>
  );
};

export default LeverageAIFinalThoughts; 